<span [ngClass]="textClasses()">
   {{ 'recaptcha.info_prefix' | translate }}
</span>
<a [attr.href]="`https://policies.google.com/privacy${languageParam()}`"
   target="_blank"
   [ngClass]="linkClasses()">{{ 'recaptcha.privacy_policy' | translate }}</a>
<span [ngClass]="textClasses()">
  {{ 'recaptcha.separator' | translate }}
</span>
<a [attr.href]="`https://policies.google.com/terms${languageParam()}`"
   target="_blank"
   [ngClass]="linkClasses()">{{ 'recaptcha.terms_of_service' | translate }}</a>
<span [ngClass]="textClasses()">
   {{ 'recaptcha.suffix' | translate }}
</span>
